
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid",
      function () {
        return require("private-next-pages/covid.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid"])
      });
    }
  